import React, { Component } from "react";
import ICON from "../icons.js";
import { stripJuristic } from "../../../components/text-sanitize.js";

/* ============================================================================
 * HomeHero — ภาพหลัก + พาดหัว + กล่องค้นหาห้อง
 * - ภาพพื้นหลังมาจากหน้าตั้งค่าเว็บไซต์ขาย (section "background")
 *   หลายรูป = สไลด์สลับเอง · ไม่มีรูปเลยก็ยังอ่านออก เพราะมีพื้นไล่สีรองอยู่ใต้ภาพ
 * - กล่องค้นหาเป็นแถบเดียว : โครงการ / ประเภทประกาศ / ช่วงราคา / เลขห้อง
 *   ค่าที่เลือกเก็บใน state แล้วส่งกลับผ่าน props.onSearch
 * ========================================================================== */
export default class HomeHero extends Component {
    state = { slide: 0 };

    componentDidMount() {
        this.startAutoplay();
    }

    componentDidUpdate(prevProps) {
        // รูปมาทีหลัง (โหลด API เสร็จ) ต้องตั้งนาฬิกาใหม่เมื่อจำนวนรูปเปลี่ยน
        if (prevProps.slides !== this.props.slides) this.startAutoplay();
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    startAutoplay = () => {
        clearInterval(this.timer);
        if ((this.props.slides || []).length < 2) return;
        this.timer = setInterval(() => this.setState((s) => ({ slide: s.slide + 1 })), 6000);
    };

    field = (icon, node) => (
        <div className="hm-field">
            <span className="hm-field__icon hm-ico">{icon}</span>
            {node}
        </div>
    );

    render() {
        const { slides = [], hero, filters, budgets, projects, onChange, onSearch } = this.props;
        const { slide } = this.state;
        const current = slides.length ? slide % slides.length : 0;

        return (
            <section className="hm-hero">
                {/* ★ ภาพพื้นหลังอยู่แค่แถบบนนี้ ไม่ใช่ทั้งหน้า
                    ฝ้าขาว (hm-hero__veil) ไล่จากซ้ายทึบไปขวาโปร่ง
                    ตัวหนังสือฝั่งซ้ายจึงอ่านออก ส่วนภาพยังเห็นชัดฝั่งขวา */}
                {/* ★ โหลดรูปเฉพาะสไลด์ที่กำลังโชว์ + สไลด์ถัดไป (เตรียมไว้ให้จางเข้าได้ทันที)
                    เดิม render รูป 1920px ครบทุกสไลด์ตั้งแต่เปิดหน้า มือถือต้องโหลดหลาย MB ก่อนเห็นอะไร
                    slide ในนาฬิกานับขึ้นอย่างเดียว (ไม่วนกลับ 0) — i <= slide + 1 จึงเก็บสไลด์ที่เคยโหลดแล้วไว้ด้วย
                    ไม่ต้องโหลดซ้ำตอนวนกลับมา */}
                <div className="hm-hero__bg">
                    {slides.map((src, i) => (
                        <div key={src} className={`hm-hero__slide ${i === current ? "is-active" : ""}`} aria-hidden={i !== current}>
                            {i <= slide + 1 && <img src={src} alt="" decoding="async" loading={i === 0 ? "eager" : "lazy"} />}
                        </div>
                    ))}
                </div>
                <div className="hm-hero__veil" />

                <div className="hm-container">
                    <div className="hm-hero__head">
                        <h1 className="hm-hero__title">
                            {stripJuristic(hero?.title) || "ห้องชุดประกาศขายและให้เช่า"}
                        </h1>
                        <p className="hm-hero__sub">
                            {stripJuristic(hero?.subtitle) || "ตรวจสอบสถานะห้องได้จริงทุกห้อง"}
                        </p>
                    </div>

                    {/* ---------------------------------------------------- กล่องค้นหา */}
                    <div className="hm-search">
                        <div className="hm-search__panel">
                            {this.field(
                                ICON.marker,
                                <select
                                    className="hm-field__select"
                                    aria-label="โครงการ"
                                    value={filters.project_id}
                                    onChange={(e) => onChange("project_id", e.target.value)}
                                >
                                    <option value="">ทุกโครงการ ({projects.length})</option>
                                    {projects.map((p) => (
                                        <option key={p.project_id} value={p.project_id}>
                                            {stripJuristic(p.project_name)} ({p.listing_count})
                                        </option>
                                    ))}
                                </select>
                            )}

                            {this.field(
                                ICON.tag,
                                <select
                                    className="hm-field__select"
                                    aria-label="ประเภทประกาศ"
                                    value={filters.listing_type}
                                    onChange={(e) => onChange("listing_type", e.target.value)}
                                >
                                    <option value="">ทั้งขายและเช่า</option>
                                    <option value="ขาย">ประกาศขาย</option>
                                    <option value="เช่า">ประกาศให้เช่า</option>
                                </select>
                            )}

                            {this.field(
                                ICON.money,
                                <select
                                    className="hm-field__select"
                                    aria-label="ช่วงราคา"
                                    value={filters.budget}
                                    onChange={(e) => onChange("budget", e.target.value)}
                                >
                                    {budgets.map((i) => (
                                        <option key={i.value} value={i.value}>{i.label}</option>
                                    ))}
                                </select>
                            )}

                            {/* ซ่อนช่องค้นหาเลขห้อง ตามคำสั่งผู้ใช้ 19 ต.ค. 2569 (เปิดกลับ: เอา comment ออก + คืน data_search ใน index.js buildParams)
                            {this.field(
                                ICON.home,
                                <input
                                    type="text"
                                    className="hm-field__select"
                                    aria-label="ค้นหาเลขห้อง"
                                    placeholder="ค้นหาเลขห้อง เช่น 101/1"
                                    value={filters.data_search}
                                    onChange={(e) => onChange("data_search", e.target.value)}
                                    onKeyUp={(e) => e.key === "Enter" && onSearch()}
                                />
                            )}
                            */}

                            <button type="button" className="hm-btn hm-btn--primary hm-search__submit" onClick={onSearch}>
                                <span className="hm-ico">{ICON.search}</span>
                                ค้นหาห้อง
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
